export const BOOKING_CANCELLED = 'booking-cancelled';
const bookingCancelled = ({ booking }) => ({
  type: BOOKING_CANCELLED,
  payload: { booking },
});

export default bookingCancelled;
